module.exports = __webpack_public_path__ + "static/media/16.1fee4359.png";